import { render, staticRenderFns } from "./AddQuestionType.vue?vue&type=template&id=172fc8b2&scoped=true&"
import script from "./AddQuestionType.vue?vue&type=script&lang=js&"
export * from "./AddQuestionType.vue?vue&type=script&lang=js&"
import style0 from "./AddQuestionType.vue?vue&type=style&index=0&id=172fc8b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172fc8b2",
  null
  
)

export default component.exports